import { create } from 'zustand'

interface TechnicianPageState {
  currentPage: string | null
  setCurrentPage: (pageId: string) => void
  getCurrentPage: () => string | null

  currentTechnician: string | null
  setCurrentTechnician: (name: string) => void

  visitedPages: string[]
  addVisitedPage: (pageId: string) => void

  reset: () => void

  commentsEnabled: boolean
  setCommentsEnabled: (isEnabled: boolean) => void

  currentSessionId: string | null
  setCurrentSessionId: (sessionId: string | null) => void

  lastSessionEventId: string | null
  setLastSessionEventId: (sessionId: string | null) => void
}

export const useTechnicianPageStore = create<TechnicianPageState>(
  (set, get) => ({
    currentPage: null,
    setCurrentPage: (pageId: string) => set({ currentPage: pageId }),
    getCurrentPage: () => get().currentPage,

    currentTechnician: null,
    setCurrentTechnician: (name: string) => set({ currentTechnician: name }),

    visitedPages: [],
    addVisitedPage: (pageId: string) =>
      set((state) => ({ visitedPages: [...state.visitedPages, pageId] })),

    reset: () =>
      set({
        currentPage: null,
        currentTechnician: null,
        currentSessionId: null,
        lastSessionEventId: null,
        visitedPages: [],
        commentsEnabled: false,
      }),

    commentsEnabled: false,
    setCommentsEnabled: (isEnabled: boolean) =>
      set({
        commentsEnabled: isEnabled,
      }),

    currentSessionId: null,
    setCurrentSessionId: (sessionId: string | null) =>
      set({ currentSessionId: sessionId }),

    lastSessionEventId: null,
    setLastSessionEventId: (sessionEventId: string | null) =>
      set({ lastSessionEventId: sessionEventId }),
  }),
)
